import { ApolloLink } from "apollo-link";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";

export function createApolloClient({ uri, context }) {
  const httpLink = createHttpLink({
    uri,
    fetch(uri, options) {
      const { operationName } = JSON.parse(options.body);
      return fetch(`${uri}/?opname=${operationName}`, options);
    }
  });

  const requestLink = new ApolloLink((operation, forward) => {
    if (context) {
      operation.setContext(context());
    }

    return forward(operation).map(response => {
      // 过滤apollo 自带的__typename
      /* eslint-disable */
      let filterData = JSON.stringify(response).replace(/\,"__typename\"[:]\"[0-9a-zA-Z_|!|(|)]{1,}\"/g, "");

      return JSON.parse(filterData);
    });
  });

  const errorLink = onError(function({ response }) {
    console.error(response);
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: errorLink.concat(requestLink.concat(httpLink)),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache"
      },
      query: {
        fetchPolicy: "no-cache"
      }
    }
  });
}

let Apollo_url = "";

switch (window.location.host) {
  case "172.16.27.117:8003":
    Apollo_url = "//speedwork-my-dev.gtech.asia/graphql";
    break;
  case "speedbiz.id.gtech.asia":
    Apollo_url = "https://speedwork.my.gtech.asia/graphql";
    break;
  case "speedbiz-my-test.gtech.asia":
    Apollo_url = "https://speedwork-my-test.gtech.asia/graphql";
    break;
  default:
    Apollo_url = "//speedwork-my-dev.gtech.asia/graphql";
    break;
}

console.log(Apollo_url, "url");
// 默认的阿波罗实例
export default createApolloClient({ uri: Apollo_url, context: null });
